// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6712341e","422":"8421e654"}[chunkId] + ".chunk.js";
};